import type React from "react";
import { Badge } from "@/components/ui/badge";
import { TIER_LABELS, type TierId } from "@/lib/format";

const TIER_VARIANT = {
  high: "tier-atrisk",
  watch_list: "tier-watch",
  on_track: "tier-on-track",
  excellent: "tier-excellent",
} as const satisfies Record<TierId, React.ComponentProps<typeof Badge>["variant"]>;

function isTierId(t: string): t is TierId {
  return t in TIER_LABELS;
}

export function TierBadge({ tier }: { tier: string }): React.JSX.Element | null {
  if (!tier) return null;
  const label = isTierId(tier) ? TIER_LABELS[tier] : tier;
  const variant = isTierId(tier) ? TIER_VARIANT[tier] : "outline";
  return <Badge variant={variant}>{label}</Badge>;
}
